// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#business-register-screen .review-banner {
  background-color: #f0f0f0;
  border-left: 0.25rem solid var(--primary-color);
  padding: 1rem;
  margin: 1rem 1rem 0 1rem;
}
#business-register-screen .review-banner .revision-fields {
  margin: 0.5rem 0 0 0;
  padding-left: 1.25rem;
}
#business-register-screen .review-banner .revision-fields li b {
  font-weight: 600;
}
#business-register-screen .carousel-content {
  transition: 0.6s;
}
#business-register-screen .carousel-content.current {
  min-height: 1rem;
  height: auto;
}
#business-register-screen .carousel-content .options-container {
  margin-bottom: 1rem;
  width: 80%;
}
#business-register-screen .carousel-content .options-container .options-title {
  margin-bottom: 2rem;
}
#business-register-screen .carousel-content .options-container .options {
  display: flex;
  align-items: center;
  justify-content: center;
}
#business-register-screen .carousel-content .options-container .option {
  cursor: pointer;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s;
  background-color: #ffffff;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
#business-register-screen .carousel-content .options-container .option.selected {
  background-color: var(--primary-color);
  color: var(--primary-text-color);
}
#business-register-screen .carousel-content .pending-image {
  width: 100%;
  height: 50vh;
  object-fit: contain;
}
@media (max-width: calc(768px - 0.063rem)) {
  #business-register-screen .carousel-content .pending-image.disapear-on-mobile {
    display: none;
  }
}
#business-register-screen .carousel-content .bank-actions .ant-tabs-nav {
  margin-bottom: 1.5rem;
}
#business-register-screen .carousel-content .bank-actions .bank-tooltip .bank-tooltip-icon {
  font-size: 1rem;
  margin-left: 0.5rem;
  color: var(--primary-button-color);
}
#business-register-screen .carousel-content .bank-actions .ant-tabs-content-holder {
  margin: 0 1rem 1rem 1rem;
}
#business-register-screen .carousel-content .pdf-warning {
  display: flex;
  width: 100%;
  align-items: center;
  background-color: #f0f0f0;
  justify-content: space-between;
  padding: 0.7rem;
  margin: 1rem 0rem;
}
#business-register-screen .carousel-content .pdf-warning .anticon-exclamation-circle {
  margin-right: 0.7rem;
}
#business-register-screen .carousel-content #iframepdf {
  width: 100%;
  height: 80vh;
}
#business-register-screen .carousel-content .business-form-card > h3 {
  padding-bottom: 2.5rem !important;
}
@media (max-width: 768px) {
  #business-register-screen .carousel-content {
    margin-bottom: 4rem;
  }
}
#business-register-screen .slick-slide {
  pointer-events: auto !important;
}
.confirm-bank-account-body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.confirm-bank-account-body .confirm-modal-image {
  max-height: 10.813rem;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
}
.business-users-list-container,
.add-business-user-buttons-container {
  padding: 0 0.5rem;
}
@media (max-width: 768px) {
  .ant-modal-title {
    margin-right: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/BusinessBadesulMicrocreditoRegisterScreen/styles.less"],"names":[],"mappings":"AAAA;EAEI,yBAAA;EACA,+CAAA;EACA,aAAA;EACA,wBAAA;AAAJ;AALA;EAQM,oBAAA;EACA,qBAAA;AAAN;AATA;EAaU,gBAAA;AADV;AAZA;EAoBI,gBAAA;AALJ;AAOI;EACE,gBAAA;EACA,YAAA;AALN;AAnBA;EA4BM,mBAAA;EACA,UAAA;AANN;AAvBA;EA+BQ,mBAAA;AALR;AA1BA;EAkCQ,aAAA;EACA,mBAAA;EACA,uBAAA;AALR;AA/BA;EAuCQ,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;AALR;AAMQ;EACE,sCAAA;EACA,gCAAA;AAJV;AAhDA;EA0DM,WAAA;EACA,YAAA;EACA,mBAAA;AAPN;AAQM;EACE;IACE,aAAA;EANR;AACF;AA1DA;EAsEQ,qBAAA;AATR;AA7DA;EA2EU,eAAA;EACA,mBAAA;EACA,kCAAA;AAXV;AAlEA;EAkFQ,wBAAA;AAbR;AArEA;EAuFM,aAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AAfN;AA9EA;EA+FQ,oBAAA;AAdR;AAjFA;EAmGM,WAAA;EACA,YAAA;AAfN;AArFA;EAyGQ,iCAAA;AAjBR;AAqBI;EAAA;IACE,mBAAA;EAlBJ;AACF;AA7FA;EAoHI,+BAAA;AApBJ;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AArBF;AAiBA;EAOI,qBAAA;EACA,mBAAA;EACA,qBAAA;AArBJ;AAyBA;;EAEE,iBAAA;AAvBF;AA0BA;EACE;IACE,oBAAA;EAxBF;AACF","sourcesContent":["#business-register-screen {\n  .review-banner {\n    background-color: #f0f0f0;\n    border-left: 0.25rem solid var(--primary-color);\n    padding: 1rem;\n    margin: 1rem 1rem 0 1rem;\n\n    .revision-fields {\n      margin: 0.5rem 0 0 0;\n      padding-left: 1.25rem;\n\n      li {\n        b {\n          font-weight: 600;\n        }\n      }\n    }\n  }\n\n  .carousel-content {\n    transition: 0.6s;\n\n    &.current {\n      min-height: 1rem;\n      height: auto;\n    }\n\n    .options-container {\n      margin-bottom: 1rem;\n      width: 80%;\n      .options-title {\n        margin-bottom: 2rem;\n      }\n      .options {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .option {\n        cursor: pointer;\n        width: 2.75rem;\n        height: 2.75rem;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: 0.4s;\n        background-color: #ffffff;\n        font-size: 1rem;\n        margin-bottom: 0.5rem;\n        &.selected {\n          background-color: var(--primary-color);\n          color: var(--primary-text-color);\n        }\n      }\n    }\n\n    .pending-image {\n      width: 100%;\n      height: 50vh;\n      object-fit: contain;\n      @media (max-width: calc(@md-screen - 0.063rem)) {\n        &.disapear-on-mobile {\n          display: none;\n        }\n      }\n    }\n\n    .bank-actions {\n      .ant-tabs-nav {\n        margin-bottom: 1.5rem;\n      }\n\n      .bank-tooltip {\n        .bank-tooltip-icon {\n          font-size: 1rem;\n          margin-left: 0.5rem;\n          color: var(--primary-button-color);\n        }\n      }\n\n      .ant-tabs-content-holder {\n        margin: 0 1rem 1rem 1rem;\n      }\n    }\n\n    .pdf-warning {\n      display: flex;\n      width: 100%;\n      align-items: center;\n      background-color: #f0f0f0;\n      justify-content: space-between;\n      padding: 0.7rem;\n      margin: 1rem 0rem;\n      .anticon-exclamation-circle {\n        margin-right: 0.7rem;\n      }\n    }\n    #iframepdf {\n      width: 100%;\n      height: 80vh;\n    }\n\n    .business-form-card {\n      > h3 {\n        padding-bottom: 2.5rem !important;\n      }\n    }\n\n    @media (max-width: @md-screen) {\n      margin-bottom: 4rem;\n    }\n  }\n\n  // corrige nao conseguir clicar nos campos\n  .slick-slide {\n    pointer-events: auto !important;\n  }\n}\n.confirm-bank-account-body {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  .confirm-modal-image {\n    max-height: 10.813rem;\n    margin-top: 0.75rem;\n    margin-bottom: 1.5rem;\n  }\n}\n\n.business-users-list-container,\n.add-business-user-buttons-container {\n  padding: 0 0.5rem;\n}\n\n@media (max-width: @md-screen) {\n  .ant-modal-title {\n    margin-right: 1.5rem;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
